module.exports = __webpack_public_path__ + "static/media/RedPay.4ad5ffb2.png";